import { Box, Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import DialogActionButtons from "../../../../components/dialog/DialogActions";
import DialogBody from "../../../../components/dialog/DialogBody";
import DialogHeader from "../../../../components/dialog/DialogHeader";

// Custom dialog styles
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

const StudentIdCardDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setOpen(true);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader title={"Student ID Card"} onClose={handleClose} />
      <DialogBody>
        <Box height={200}></Box>
      </DialogBody>
      <DialogActionButtons onCancel={handleClose} onConfirm={handleClose} />
    </BootstrapDialog>
  );
});

export default StudentIdCardDialog;
